import React, { useContext, useState } from 'react';
import AppContext from './AppContext';
import GlobalNav from './globalNav/GlobalNav';
import ModelSelectorList from './ModelSelectorList/ModelSelectorList';
import Footer from './footer/Footer';
import AdChoicesModal from './AdChoicesModal/AdChoicesModal';
import WarningModal from './WarningModal/WarningModal';

const Main = () => {
  const { language, country } = useContext(AppContext);
  const [showAdChoicesModal, setShowAddChoicesModal] = useState(false);
  const [showWarningModal, setShowWarningModal] = useState(false);
  const [vsUrl, setVsUrl] = useState(null);

  return (
    <React.Fragment>
      <GlobalNav />
      <ModelSelectorList
        onViewInventoryClicked={url => {
          setShowWarningModal(true);
          setVsUrl(url);
        }}
      />
      <Footer
        country={country}
        lang={language}
        onAdChoicesClicked={() => setShowAddChoicesModal(true)}
      />
      <AdChoicesModal
        country={country}
        lang={language}
        isOpen={showAdChoicesModal}
        onAdChoicesClose={() => setShowAddChoicesModal(false)}
      />
      <WarningModal
        isOpen={showWarningModal}
        onWarningModalClose={() => setShowWarningModal(false)}
        vsUrl={vsUrl}
      />
    </React.Fragment>
  );
};

export default Main;
